const TEXTS = {
  ITEM_LIST_SELECT_ALl: 'Включить все',
  ITEM_LIST_SELECT_NONE: 'Отключить все',
};

export default TEXTS;
